<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('customer')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="p-grid p-field">
                                    <div class="p-row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Create_Date)}} 
                                    </div>
                                    <div class="p-row">
                                        by {{header.Create_By}}
                                    </div>
                                </div>
                                <div class="p-grid p-field" v-if="header.Edit_Date">
                                    <div class="p-row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edit_Date)}} 
                                    </div>
                                    <div class="p-row">
                                        by {{header.Edit_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" v-if="canSave" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView>
                        <TabPanel header="Header & Detail">
                            <div v-if="header && isOverNotAccess">
                                <Message severity="warn" :closable="false">
                                    {{ $t('inactive_account') }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
                                </Message>
                            </div>
                            <div class="grid">
                                <div class="col-6">
                                    <FormField :labelName="$t('code')" fieldName="Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Code" v-model="header.Customer_Code" type="text" :placeholder="$t('code')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('name')" fieldName="Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Name1" v-model="header.Customer_Name1" type="text" :placeholder="$t('name')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('name2')" fieldName="Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Name2" v-model="header.Customer_Name2" type="text" :placeholder="$t('name2')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('name3')" fieldName="Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Name3" v-model="header.Customer_Name3" type="text" :placeholder="$t('name3')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('name4')" fieldName="Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Name4" v-model="header.Customer_Name4" type="text" :placeholder="$t('name4')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('street')" fieldName="Street" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Textarea name="Address" v-model="header.Street" type="text" :placeholder="$t('street')"  v-if="header" :disabled="true" :autoResize="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('address2')" fieldName="Address" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Textarea name="Address" v-model="header.Address2" type="text" :placeholder="$t('address2')"  v-if="header" :disabled="true" :autoResize="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('address3')" fieldName="Address" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Textarea name="Address" v-model="header.Address3" type="text" :placeholder="$t('address3')"  v-if="header" :disabled="true" :autoResize="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('address4')" fieldName="Address" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Textarea name="Address" v-model="header.Addres4" type="text" :placeholder="$t('address4')"  v-if="header" :disabled="true" :autoResize="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('address5')" fieldName="Address" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Textarea name="Address" v-model="header.Address5" type="text" :placeholder="$t('address5')"  v-if="header" :disabled="true" :autoResize="true"  />
                                    </FormField>

                                     <FormField :labelName="$t('country')" fieldName="Country" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="City" v-model="header.Country" type="text" :placeholder="$t('country')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('city')" fieldName="City" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="City" v-model="header.City" type="text" :placeholder="$t('city')"  v-if="header" :disabled="true"  />
                                    </FormField>
                                </div>
                                <div class="col-6">
                                    <FormField :labelName="$t('location')" fieldName="Location" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Location" v-model="header.Location" type="text" :placeholder="$t('location')"  v-if="header" :disabled="!canEdit"  />
                                    </FormField>

                                    <FormField :labelName="$t('transporter')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Postal_Code" v-model="header.Transporter_Code" type="text" :placeholder="$t('transporter')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('postal_code')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Postal_Code" v-model="header.Postal_Code" type="text" :placeholder="$t('postal_code')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('email')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Postal_Code" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('phone')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Telephone" v-model="header.Telephone" type="text" :placeholder="$t('phone')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('pkp_no')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Telephone" v-model="header.PKP_No" type="text" :placeholder="$t('pkp_no')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('pkp_validity')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="header" :disabled="true" />
                                    </FormField>

                                    <FormField :labelName="$t('region')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Telephone" v-model="header.Region" type="text" :placeholder="$t('region')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('region_desc')" fieldName="Region_Desc" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Region_Desc" v-model="header.Region_Desc" type="text" :placeholder="$t('region_desc')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('account_group')" fieldName="AccountGroup" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="AccountGroup" v-model="header.AccountGroup" type="text" :placeholder="$t('account_group')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                     <FormField :labelName="$t('credit_group')" fieldName="Customer_Credit_Group" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Credit_Group" v-model="header.Customer_Credit_Group" type="text" :placeholder="$t('credit_group')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                     <FormField :labelName="$t('credit_group_desc')" fieldName="Customer_Credit_Group_Description" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Customer_Credit_Group_Description" v-model="header.Customer_Credit_Group_Description" type="text" :placeholder="$t('credit_group_desc')"  v-if="header" :disabled="true"  />
                                    </FormField>

                                    <FormField :labelName="$t('port')" fieldName="Postal_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Telephone" v-model="header.Port" type="text" :placeholder="$t('port')"  v-if="header" :disabled="true"  />
                                    </FormField>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Details">
                            <DataTable v-if="header" :loading="!header.CustomerDs" :value="header.CustomerDs ? header.CustomerDs : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column field="Sales_Organization" :header="$t('sales_org')" key="Sales_Organiztion">  
                                </Column>
                                <Column field="Distribution_Channel" :header="$t('distribution_channel')" key="Distribution_Channel">  
                                </Column>
                                <Column field="Division" :header="$t('division')" key="Sales_Organiztion">  
                                </Column>
                                <Column field="Payment_Term" :header="$t('payment_term')" key="Sales_Organiztion">  
                                </Column>
                                <Column field="IncoTerm" :header="$t('incoterm')" key="Sales_Organiztion">  
                                </Column>
                                <Column field="IncoTerm2" :header="$t('incoterm2')" key="Sales_Organiztion">  
                                </Column>
                                <Column field="Sales_District" :header="$t('sales_district')" key="Sales_District">  
                                </Column>
                            </DataTable>
                        </TabPanel>
                        <TabPanel header="Contacts">
                            <DataTable v-if="header" :loading="!header.Contacts" :value="header.Contacts ? header.Contacts : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <Column field="Company_Code" :header="$t('company')" key="Company_Code">  
                                </Column>
                                <Column field="ContactPersonNo" :header="$t('no')" key="ContactPersonNo">  
                                </Column>
                                <Column field="ContactPersonName" :header="$t('name')" key="ContactPersonName">  
                                </Column>
                                <Column field="ContactPersonDepartment" :header="$t('department')" key="ContactPersonDepartment">  
                                </Column>
                                <Column field="ContactPersonMobilePhone" :header="$t('phone')" key="ContactPersonMobilePhone">  
                                </Column>
                                <Column field="ContactPersonCity" :header="$t('city')" key="ContactPersonCity">  
                                </Column>
                            </DataTable>
                        </TabPanel>
                        <TabPanel header="Partner Function & Companies">
                            <div class="grid">
                                <div class="col-6">
                                    <DataTable v-if="header" :loading="!header.CustomerDDs" :value="header.CustomerDDs ? header.CustomerDDs : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                        <Column field="Sales_Organization" :header="$t('sales_org')" key="Sales_Organiztion">  
                                        </Column>
                                        <Column field="Distribution_Channel" :header="$t('distribution_channel')" key="Distribution_Channel">  
                                        </Column>
                                        <Column field="Division" :header="$t('division')" key="Division">  
                                        </Column>
                                        <Column field="PartnerFunction" :header="$t('partner_function')" key="PartnerFunction">  
                                        </Column>
                                        <Column field="Customer" :header="$t('customer')" key="Customer">  
                                        </Column>
                                    </DataTable>
                                </div>
                                <div class="col-6">
                                    <DataTable v-if="header" :loading="!header.Companies" :value="header.Companies ? header.Companies : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                        <Column field="Company_Code" :header="$t('company')" key="Company_Code">  
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                            
                        </TabPanel>
                        <TabPanel header="User">
                            <FormField :labelName="$t('username')" fieldName="Employee_Number" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputText name="Employee_Number" v-model="header.Users[0].Employee_Number" type="text" :placeholder="$t('username')"  v-if="header" :disabled="!canEdit" @change="edituser(header.Users[0])" /> 
                            </FormField>

                             <FormField :labelName="$t('full_name')" fieldName="Full_Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputText name="Full_Name" v-model="header.Users[0].Full_Name" type="text" :placeholder="$t('full_name')"  v-if="header" :disabled="!canEdit"  @change="edituser(header.Users[0])" /> 
                            </FormField>

                            <FormField :labelName="$t('password')" fieldName="Password" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <!-- <InputText name="Password" v-model="header.Users[0].Password" type="text" :placeholder="$t('password')"  v-if="header" :disabled="!canEdit"  @change="edituser(header.Users[0])" />  -->
                                <Password name="Password" v-model="header.Users[0].Password" :placeholder="$t('password')"  v-if="header" :disabled="!canEdit"  @change="edituser(header.Users[0])" :feedback="false" :toggleMask="true"/> 
                            </FormField>

                             <FormField :labelName="$t('contact_person')" fieldName="Contact_Person" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputText name="Contact_Person" v-model="header.Users[0].Contact_Person" type="text" :placeholder="$t('contact_person')"  v-if="header" :disabled="!canEdit"   @change="edituser(header.Users[0])"/> 
                            </FormField>

                             <FormField :labelName="$t('phone')" fieldName="Phone" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputText name="Phone" v-model="header.Users[0].Phone" type="text" :placeholder="$t('phone')"  v-if="header" :disabled="!canEdit"  @change="edituser(header.Users[0])" /> 
                            </FormField>

                             <FormField :labelName="$t('email')" fieldName="Email" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <InputText name="Email" v-model="header.Users[0].Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="!canEdit"  @change="edituser(header.Users[0])" /> 
                            </FormField>

                            <FormField labelName="Lock/Unlock Account" fieldName="Lock_Unlock" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                <Button label="Lock/Unlock Account" class="p-button-warning" v-if="header" :disabled="!canEdit" @click="openDialog" />
                            </FormField>
                        </TabPanel>
                    </TabView>
                    
                </div>
            </template>
        </Card>
    </form>

    <Dialog header="Lock/Unlock Account" v-model:visible="displayDialog" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}">
        <div>
            <Message severity="warn" :closable="false">
				{{ inactive_msg }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
			</Message>
            <h6 id="single">Please select lock or unlock account</h6>
            <SelectButton v-model="Is_Locked" :options="lockOption" optionLabel="name" optionValue="value" aria-labelledby="single" />
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" @click="closeDialog" class="p-button-text"/>
            <Button label="Save" icon="pi pi-check" @click="saveLockUser" />
        </template>
    </Dialog>
</template>


<script>

    export default {
        name: "Editor",
        data() {
            return {
                indexName: "CustomerIndex",
                url: this.$API_URL + "customer/",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                formEditable: true,
                
                detailModel: null,
                userModel: null,

                Is_Locked: null,
                lockOption: [
                    {name: 'Lock', value: true},
                    {name: 'Unlock', value: false},
                ],
                displayDialog:false,
                inactive_msg: ''

            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.userModel = response.data.data.user;
                        self.Is_Locked = response.data.data.header.Users.length > 0 ? response.data.data.header.Users[0].Is_Blocked : null;

                        if(self.header.Users.length == 0)
                        {
                            var um = {...self.userModel};
                            um.mode = self.$FORM_MODE_CREATE;
                            self.header.Users.push(um);   
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            saveData() {
                var self = this;
                this.$emit('block-ui');
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.$emit('unblock-ui');
                            self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.message, life: 120000});
                        }
                    })
                    .catch(function (error) {
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000});
                        self.$emit('unblock-ui');
                    });
            },
            saveLockUser(){
                var self = this;
                var data = {
                    "user_id": this.header.Users[0].Id,
                    "is_locked": this.Is_Locked
                };

                this.$emit('block-ui');
                this.$axios.post(this.$API_URL + "util/user_lock_unlock/", data)
                .then((response) => {
                    self.getData();
                    self.$emit('unblock-ui');
                    self.closeDialog();
                    if (response.data.success){
                        self.$toast.add({ severity: 'success', summary: 'Success Saving Data', detail: "Customer account has been saved successfully.", life: 50000});
                    }
                    else{
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000});
                    }
                })
                .catch(function (error) {
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000});
                    self.$emit('unblock-ui');
                });
            },
            backToIndex() {
                this.$router.push({ path: "/Customer/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
            openDialog(){
                this.inactiveMsg();
                this.displayDialog = true;
            },
            closeDialog(){
                this.displayDialog = false;
                this.Is_Locked = this.header.Users[0].Is_Blocked;
            },
            inactiveMsg(){
                var userAccount = this.header.Users;
                var lastAccessDate = userAccount.length > 0 ? new Date(this.$moment(userAccount[0].Last_Access_Date).format('L')) : null;
                var currentDate = new Date(this.$moment(new Date()).format('L'));

                var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
                var totalDays = lastDuration / (1000 * 3600 * 24);

                if(isNaN(totalDays)){
                    this.inactive_msg = "This account has never been active. ";
                }
                else{
                    this.inactive_msg = "This account has been inactive for "+totalDays+" days. ";
                }
            }
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed:{
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            },
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            },
            isOverNotAccess(){
                var duration = 90;
                var userAccount = this.header.Users;
                var lastAccessDate = userAccount.length > 0 ? new Date(this.$moment(userAccount[0].Last_Access_Date).format('L')) : null;
                var currentDate = new Date(this.$moment(new Date()).format('L'));

                if(userAccount[0].Id > 0){
                    if(userAccount[0].Last_Access_Date == null){
                        return true;
                    }
                    else{
                        var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
                        var totalDays = lastDuration / (1000 * 3600 * 24);

                        if(totalDays >= duration){
                            return true;
                        }

                        return false;
                    }
                }
                else{
                    return false;
                }
            }
        }
    }
</script>